import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_event/$eventSlug/quizzes/$quizId/iniciar'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/quizzes/${params.quizId}/iniciar`,
      replace: true
    })
  }
})
